import {FirebaseError} from "firebase/app";
import {doc, serverTimestamp, setDoc} from "firebase/firestore";
import {db} from "../firebaseConfig.ts";
import type {ClientAttribution} from "./reader";

const ALLOWED_TYPES = new Set(["gclid", "wbraid", "gbraid"]);

export type RecordAttributionInput = {
    uid: string;
    attr: ClientAttribution | null | undefined;
    sourceHost?: string;
};

export async function recordAttributionForUser(
    {
        uid,
        attr,
        sourceHost,
    }: RecordAttributionInput): Promise<void> {
    if (!attr) {
        return;
    }

    if (!ALLOWED_TYPES.has(attr.type)) {
        return;
    }

    if (!attr.value) {
        return;
    }

    const attributionDoc = doc(db, "attributions", uid);

    const payload: Record<string, unknown> = {
        schema: 1,
        click_id_type: attr.type,
        click_id_value: attr.value,
        first_seen_at: serverTimestamp(),
    };

    if (sourceHost) {
        payload.source_host = sourceHost;
    }

    try {
        await setDoc(attributionDoc, payload);
    } catch (error) {
        if (error instanceof FirebaseError) {
            if (error.code === "permission-denied") return;
            if (error.code === "already-exists") return;
        }
        throw error;
    }
}
